import { render, staticRenderFns } from "./ModalMedicalPractice.vue?vue&type=template&id=b5ee0f8a&scoped=true&lang=pug"
import script from "./ModalMedicalPractice.vue?vue&type=script&lang=js"
export * from "./ModalMedicalPractice.vue?vue&type=script&lang=js"
import style0 from "./ModalMedicalPractice.vue?vue&type=style&index=0&id=b5ee0f8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ee0f8a",
  null
  
)

export default component.exports